import { Image } from 'tdesign-react';

import { NumericalSystemType } from '@/interface/numberSysytem';

import { StoryNumberListData } from '.';

export const numberSysNumColumns = [
  { title: '变量名', colKey: 'name' },
  {
    title: '变量类型',
    colKey: 'type',
    cell: ({ row }: { row: StoryNumberListData }) => (
      row.type === NumericalSystemType.NS_TYPE_GLOBAL_NORMAL ? '普通变量' : '永久变量'
    ),
  },
  { title: '初始值', colKey: 'initScore' },

  {
    title: '数值范围',
    colKey: 'range',
    cell: ({ row }: { row: StoryNumberListData }) => {
      if (row?.minScore === undefined && row?.maxScore === undefined) {
        return '--';
      }
      return `${row?.minScore || 0} ~ ${row?.maxScore || 0}`;
    },
  },
  {
    title: '玩家是否可见',
    colKey: 'visible',
    cell: ({ row }: { row: StoryNumberListData }) => (
      row?.isVisible ? '是' : '否'
    ),
  },
  {
    title: '变量图标', colKey: 'icon',
    cell: ({ row }: { row: StoryNumberListData }) => (
      row?.iconUrl ? <Image
        src={row?.iconUrl}
        alt=""
        fit={'contain'}
        error={''}
        style={{ width: 26, height: 26 }}
      /> : ''
    ),
  },
];
